import { render, staticRenderFns } from "./releaseList.vue?vue&type=template&id=2e3e5e3e"
import script from "./releaseList.vue?vue&type=script&lang=js"
export * from "./releaseList.vue?vue&type=script&lang=js"
import style0 from "./releaseList.vue?vue&type=style&index=0&id=2e3e5e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports